import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // App name
      "app_name": "LCS Case Management",
      "app_description": "Gestion de dossiers clients",
      
      // Navigation
      "dashboard": "Tableau de bord",
      "files": "Dossiers",
      "employees": "Employés",
      "clients": "Clients",
      "messages": "Messages",
      "invoices": "Factures",
      "audit": "Audit",
      "profile": "Profil",
      "logout": "Déconnexion",
      
      // Auth
      "login": "Connexion",
      "email": "Courriel",
      "password": "Mot de passe",
      "full_name": "Nom complet",
      "sign_in": "Se connecter",
      "sign_up": "S'inscrire",
      "register": "S'inscrire",
      "verify_2fa": "Vérifier le code 2FA",
      "enter_code": "Entrez le code",
      "verify": "Vérifier",
      "code_sent": "Code envoyé à votre email",
      
      // Dashboard
      "welcome": "Bienvenue",
      "total_files": "Total des dossiers",
      "active_files": "Dossiers actifs",
      "closed_files": "Dossiers fermés",
      "pending_invoices": "Factures en attente",
      "total_employees": "Total des employés",
      "recent_activities": "Activités récentes",
      "statistics": "Statistiques",
      
      // Files
      "create_file": "Créer un dossier",
      "file_number": "Numéro de dossier",
      "client_name": "Nom du client",
      "status": "Statut",
      "assigned_to": "Assigné à",
      "created_at": "Créé le",
      "actions": "Actions",
      "view": "Voir",
      "edit": "Modifier",
      "delete": "Supprimer",
      "ouvert": "Ouvert",
      "en_cours": "En cours",
      "soumission_ircc": "Soumission IRCC",
      "en_traitement": "En traitement",
      "decision": "Décision",
      "ferme": "Fermé",
      
      // Documents
      "documents": "Documents",
      "upload_document": "Téléverser un document",
      "document_name": "Nom du document",
      "uploaded_by": "Téléversé par",
      "uploaded_at": "Téléversé le",
      "size": "Taille",
      "download": "Télécharger",
      "drag_drop": "Glissez-déposez des fichiers ici ou cliquez pour sélectionner",
      
      // Activities
      "activities": "Activités",
      "activity_log": "Journal d'activités",
      "user": "Utilisateur",
      "action": "Action",
      "description": "Description",
      "timestamp": "Horodatage",
      
      // Messages
      "new_message": "Nouveau message",
      "subject": "Sujet",
      "content": "Contenu",
      "send": "Envoyer",
      "from": "De",
      "to": "À",
      "unread": "Non lu",
      "read": "Lu",
      
      // Invoices
      "create_invoice": "Créer une facture",
      "amount": "Montant",
      "paid": "Payé",
      "unpaid": "Non payé",
      "pay_now": "Payer maintenant",
      "invoice_details": "Détails de la facture",
      
      // Users
      "add_employee": "Ajouter un employé",
      "role": "Rôle",
      "permissions": "Permissions",
      "active": "Actif",
      "inactive": "Inactif",
      "admin": "Administrateur",
      "employee": "Employé",
      "client": "Client",
      
      // Common
      "save": "Enregistrer",
      "cancel": "Annuler",
      "close": "Fermer",
      "search": "Rechercher",
      "filter": "Filtrer",
      "export": "Exporter",
      "loading": "Chargement...",
      "no_data": "Aucune donnée",
      "confirm": "Confirmer",
      "success": "Succès",
      "error": "Erreur",
      "warning": "Avertissement",
      "info": "Information"
    }
  },
  en: {
    translation: {
      // App name
      "app_name": "LCS Case Management",
      "app_description": "Client file management",
      
      // Navigation
      "dashboard": "Dashboard",
      "files": "Files",
      "employees": "Employees",
      "clients": "Clients",
      "messages": "Messages",
      "invoices": "Invoices",
      "audit": "Audit",
      "profile": "Profile",
      "logout": "Logout",
      
      // Auth
      "login": "Login",
      "email": "Email",
      "password": "Password",
      "full_name": "Full Name",
      "sign_in": "Sign In",
      "sign_up": "Sign Up",
      "register": "Register",
      "verify_2fa": "Verify 2FA Code",
      "enter_code": "Enter code",
      "verify": "Verify",
      "code_sent": "Code sent to your email",
      
      // Dashboard
      "welcome": "Welcome",
      "total_files": "Total Files",
      "active_files": "Active Files",
      "closed_files": "Closed Files",
      "pending_invoices": "Pending Invoices",
      "total_employees": "Total Employees",
      "recent_activities": "Recent Activities",
      "statistics": "Statistics",
      
      // Files
      "create_file": "Create File",
      "file_number": "File Number",
      "client_name": "Client Name",
      "status": "Status",
      "assigned_to": "Assigned To",
      "created_at": "Created At",
      "actions": "Actions",
      "view": "View",
      "edit": "Edit",
      "delete": "Delete",
      "ouvert": "Open",
      "en_cours": "In Progress",
      "soumission_ircc": "IRCC Submission",
      "en_traitement": "Processing",
      "decision": "Decision",
      "ferme": "Closed",
      
      // Documents
      "documents": "Documents",
      "upload_document": "Upload Document",
      "document_name": "Document Name",
      "uploaded_by": "Uploaded By",
      "uploaded_at": "Uploaded At",
      "size": "Size",
      "download": "Download",
      "drag_drop": "Drag and drop files here or click to select",
      
      // Activities
      "activities": "Activities",
      "activity_log": "Activity Log",
      "user": "User",
      "action": "Action",
      "description": "Description",
      "timestamp": "Timestamp",
      
      // Messages
      "new_message": "New Message",
      "subject": "Subject",
      "content": "Content",
      "send": "Send",
      "from": "From",
      "to": "To",
      "unread": "Unread",
      "read": "Read",
      
      // Invoices
      "create_invoice": "Create Invoice",
      "amount": "Amount",
      "paid": "Paid",
      "unpaid": "Unpaid",
      "pay_now": "Pay Now",
      "invoice_details": "Invoice Details",
      
      // Users
      "add_employee": "Add Employee",
      "role": "Role",
      "permissions": "Permissions",
      "active": "Active",
      "inactive": "Inactive",
      "admin": "Administrator",
      "employee": "Employee",
      "client": "Client",
      
      // Common
      "save": "Save",
      "cancel": "Cancel",
      "close": "Close",
      "search": "Search",
      "filter": "Filter",
      "export": "Export",
      "loading": "Loading...",
      "no_data": "No data",
      "confirm": "Confirm",
      "success": "Success",
      "error": "Error",
      "warning": "Warning",
      "info": "Information"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;